import { useEffect, useLayoutEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Typography, useMediaQuery } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { Menu } from 'menu-items/dashboard';

import { useSelector } from 'store';
import useConfig from 'hooks/useConfig';
import { HORIZONTAL_MAX_ITEM } from 'config';

// types
import { NavItemType } from 'types/menu';
import { MenuOrientation } from 'types/config';
import { cloneDeep } from 'lodash';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);
  const [selectedItems, setSelectedItems] = useState<string | undefined>('');
  const [selectedLevel, setSelectedLevel] = useState<number>(0);
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({
    items: []
  });
  const menuInstance = useSelector((state) => state?.menu?.menuInstance);

  useEffect(() => {
    handlerMenuItem();
    // eslint-disable-next-line
  }, []);

  let getMenu = Menu();
  // Anaylitcs API is being called here

  const handlerMenuItem = () => {
    const isFound = menuItem.items.some((element) => {
      if (element.id === 'group-applications') {
        return true;
      }
      return false;
    });

    if (getMenu?.id !== undefined && !isFound) {
      menuItem.items.splice(0, 0, getMenu);
      setMenuItems(menuItem);
    }
  };

  useLayoutEffect(() => {
    // const userData: any = localStorage.getItem('userRights');
    // var userRights: any;
    // if (userData) {
    //   userRights = userData.split(',');
    // }
    var menu = cloneDeep(menuItem);
    // let menuitemTemp = menu.items[0].children?.filter((el) => el?.rights?.includes(userRights));
    // console.log('menuitemTemp', menuitemTemp);
    if (menuInstance && menuInstance?.length > 0) {
      const commonValues: any = menu.items?.[0]?.children?.filter((data) => menuInstance?.some((val: any) => val?.code === data?.id));
      menu.items[0].children = commonValues;
      setMenuItems(menu);
    }
    // eslint-disable-next-line
  }, [menuItem, menuInstance]);

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems?.items?.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  //  first it checks menu item is more than giving HORIZONTAL_MAX_ITEM after that get lastItemid by giving horizontal max
  // item and it sets horizontal menu by giving horizontal max item lastly slice menuItem from array and set into remItems

  if (lastItem && lastItem < menuItems?.items?.length) {
    lastItemId = menuItems.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item: any) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon
    }));
  }

  const navGroups = menuItems.items?.slice(0, lastItemIndex + 1)?.map((item: any) => {
    switch (item?.type) {
      case 'group':
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return (
    <Box
    sx={{
      pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
      '& > ul:first-of-type': { mt: 0 },
      display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block',
      textTransform: 'uppercase',
      overflow: 'visible', // Allow overflow to be visible for wrapping
      flexWrap: 'wrap', // Allow the items to wrap onto a new line
      whiteSpace: 'normal', // Allow text to wrap
    }}
  >
    {navGroups}
  </Box>
  
  );
};

export default Navigation;
